import { useEffect } from 'react';

/**
 * Keeps --countdown-header-height (the .with-countdown wrapper padding in
 * global.css) in step with the rendered header. The countdown copy comes from
 * Builder, so it can wrap to more lines than the hand-measured CSS defaults
 * assume, which would slide the page content under the fixed header.
 *
 * Measures #header-top through #header-bottom only: the search dropdown also
 * lives in <header> and grows it when open, and the page shouldn't shift for that.
 */
export function useCountdownHeaderHeight(enabled) {
    useEffect(() => {
        const top = document.getElementById('header-top');
        const bottom = document.getElementById('header-bottom');
        if (!enabled || !top || !bottom || typeof ResizeObserver === 'undefined') return;

        const root = document.documentElement;
        const sync = () => {
            const height = bottom.getBoundingClientRect().bottom - top.getBoundingClientRect().top;
            root.style.setProperty('--countdown-header-height', `${Math.ceil(height)}px`);
        };

        sync();
        const ro = new ResizeObserver(sync);
        ro.observe(top);
        ro.observe(bottom);

        return () => {
            ro.disconnect();
            root.style.removeProperty('--countdown-header-height');
        };
    }, [enabled]);
}
